import { render, staticRenderFns } from "./AdminBlogCreate.vue?vue&type=template&id=080c66b6"
import script from "./AdminBlogCreate.vue?vue&type=script&lang=js"
export * from "./AdminBlogCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports